// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"responsiveComponents_mobileOnly__M4O5e","desktopOnly":"responsiveComponents_desktopOnly__kq9zm"};